<template>
  <div class="tag-box">
    <!--操作栏-->
    <div class="action-bar">
      <!-- <el-input
        v-model="params.name"
        placeholder="请输入积分名称"
        clearable
        size="small"
        class="param-input"
      ></el-input> -->
      <el-select
        placeholder="请输入状态"
        clearable
        size="small"
        v-model="params.status"
      >
        <el-option
          :label="item.label"
          :value="item.value"
          v-for="item in statuses"
          :key="item.value"
        ></el-option>
      </el-select>
      <el-button
        type="primary"
        size="small"
        icon="el-icon-search"
        @click="getList('status')"
        style="margin-right: 20px"
        >搜索</el-button
      >
      <el-button
        type="primary"
        size="small"
        @click="addAndEdit('add')"
        style="margin-right: 20px"
        >新增</el-button
      >
    </div>
    <!--数据表格-->
    <el-table
      :data="tableData"
      style="width: 100%"
      border
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      ref="multipleTable"
      height="600"
    >
      <el-table-column prop="id" label="ID" align="center" min-width="210">
        <template slot-scope="scope">
          <span>{{ scope.row.id || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="bgImg"
        min-width="160"
        label="背景图片"
        align="center"
      >
        <template slot-scope="scope">
          <img-load
            :width="'80px'"
            :height="'80px'"
            :src="imgUrl + scope.row.bgImg"
            v-if="scope.row.bgImg"
          >
          </img-load>
          <div v-else>暂无图片</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="name"
        label="积分名称"
        align="center"
        min-width="150"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.name || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="duration"
        label="积分持续天数"
        align="center"
        min-width="150"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.duration }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="price"
        label="积分价格"
        align="center"
        min-width="150"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.price }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="prizePrice"
        label="奖品价格"
        align="center"
        min-width="150"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.prizePrice }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="prize"
        label="奖品类型"
        align="center"
        min-width="150"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.prize === 1">VIP</span>
          <span v-else-if="scope.row.prize === 2">AI换脸</span>
          <span v-else-if="scope.row.prize === 3">金币加赠券</span>
          <span v-else-if="scope.row.prize === 4">观影券</span>
          <span v-else-if="scope.row.prize === 5">AI脱衣</span>
          <span v-else-if="scope.row.prize === 6">盲盒</span>
          <span v-else>--</span>
        </template>
      </el-table-column>
      <el-table-column prop="desc" label="描述" align="center" min-width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.desc || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="status"
        label="状态"
        align="center"
        min-width="120"
      >
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.status">开启</el-tag>
          <el-tag v-else>关闭</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="updateAct"
        label="修改账号"
        align="center"
        min-width="150"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.updateAct || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="updateTime"
        label="修改时间"
        align="center"
        min-width="180"
      >
        <template slot-scope="scope">
          <span>{{ changeTime(scope.row.updateTime) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="创建时间"
        align="center"
        min-width="180"
      >
        <template slot-scope="scope">
          <span>{{ changeTime(scope.row.createTime) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        min-width="180"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="success"
            icon="el-icon-edit"
            @click="addAndEdit(scope.row)"
            >编辑</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <el-pagination
      :page-sizes="[10, 15, 20, 30]"
      :current-page="params.page"
      :page-size="params.limit"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      background
      @size-change="changeSize"
      @current-change="changeCurrent"
    ></el-pagination>
    <!-- 新增、修改 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="530px"
      @before-close="handleClose"
      @close="handleClose"
    >
      <el-form :model="form" label-width="140px" :rules="rules" ref="form">
        <el-form-item label="背景:" prop="activityId">
            <base-upload
              :cover="form.bgImg"
              :action="actionPics"
              @successCallback="successCallback"
              :id="id"
              :wSize="184"
              :hSize="184"
            ></base-upload>
          </el-form-item>
        <el-form-item label="积分名称" prop="name" style="width: 400px">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="积分持续天数" prop="duration" style="width: 400px">
          <el-input v-model.number="form.duration"></el-input>
        </el-form-item>
        <el-form-item label="描述" prop="desc" style="width: 400px">
          <el-input type="textarea" :rows="5" v-model="form.desc"></el-input>
        </el-form-item>
        <el-form-item label="积分价格" prop="price" style="width: 400px">
          <el-input v-model.number="form.price"></el-input>
        </el-form-item>
        <el-form-item label="奖品价值" prop="prizePrice" style="width: 400px">
          <el-input v-model.number="form.prizePrice"></el-input>
        </el-form-item>
        <el-form-item label="奖品类型" prop="prize" style="width: 400px">
          <el-select v-model="form.prize" clearable>
            <el-option
              :label="item.label"
              :value="item.value"
              v-for="item in prizeTypes"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态" prop="status" style="width: 400px">
          <el-select v-model="form.status">
            <el-option
              :label="item.label"
              :value="item.value"
              v-for="item in statuses"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" size="small" @click="onSubmit()"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import API from "@/api";
import baseConfig from "@/utils/serverUrlConfig";
import { uniteDate } from "@/utils/validator.js";
export default {
  data() {
    return {
      //图集上传
      actionPics: baseConfig.baseServerUrl + "/vid/uploadStatic",
      // 表格数据加载动画
      loading: false,
      // 列表数据
      tableData: [],
      total: 0,
      imgUrl: baseConfig.imgUrl,
      params: {
        page: 1,
        limit: 10,
        status: undefined, // 状态
        name: undefined, // 积分名称
      },
      rules: {
        name: [{ required: true, message: "请输入积分名称", trigger: "blur" }],
        duration: [
          { required: true, message: "请输入积分持续天数", trigger: "blur" },
        ],
        price: [{ required: true, message: "请输入积分价格", trigger: "blur" }],
      },
      statuses: [
        {
          label: "开启",
          value: true,
        },
        {
          label: "关闭",
          value: false,
        },
      ],
      prizeTypes: [
        {
          label: "VIP",
          value: 1,
        },
        {
          label: "AI换脸",
          value: 2,
        },
        {
          label: "金币加赠券",
          value: 3,
        },
        {
          label: "观影券",
          value: 4,
        },
        {
          label: "AI脱衣",
          value: 5,
        },
        {
          label: "盲盒",
          value: 6,
        },
      ],
      dialogTitle: "",
      dialogVisible: false,
      form: {
        id: undefined,
        name: "", // 积分名称
        duration: 0, // 积分持续天数
        desc: undefined, // 描述
        price: 0, // 积分价格
        prizePrice: undefined, // 奖品价值
        prize: undefined, // 奖品类型
        status: 1, // 状态，1 开启 2关闭 默认为1
        bgImg: "",
      },
    };
  },
  created() {
    this.getList();
  },
  methods: {
    // 上传成功
    successCallback(res) {
      this.form.bgImg = res.data.coverImg;
    },
    getList(type) {
      if (type === "status") {
        this.params.page = 1;
      }
      API.getIntegralConfigList(this.params)
        .then((res) => {
          if (res.code === 200 && res.data) {
            this.tableData = res.data.list;
            this.total = res.data.total;
          } else {
            this.tableData = [];
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 标签封面上传成功回掉
    handleAvatarSuccess(res) {
      this.form.icon = res.data.coverImg;
    },
    // 新增标签配置
    addAndEdit(param) {
      if (param === "add") {
        this.dialogTitle = "新增";
      } else {
        this.dialogTitle = "编辑";
        // 把数据回显给表单
        this.form.id = param.id;
        this.form.name = param.name;
        this.form.duration = param.duration;
        this.form.bgImg = param.bgImg;
        this.form.desc = param.desc;
        this.form.price = param.price;
        this.form.prizePrice = param.prizePrice;
        this.form.prize = param.prize;
        this.form.status = param.status;
      }
      this.dialogVisible = true; // 打开新增、编辑对话框
    },
    // 新增、修改提交
    onSubmit() {
      if (this.dialogTitle === "新增") {
        this.add();
      } else {
        this.edit();
      }
    },
    // 新增方法
    add() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.form.type = Number(this.form.type);
          API.addIntegralConfig(this.form).then((res) => {
            if (res.code === 200) {
              this.$message({
                type: "success",
                message: "新增成功",
              });
              this.dialogVisible = false;
              this.getList();
            } else {
              this.$message({
                type: "error",
                message: "新增失败",
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    // 修改方法
    edit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.form.type = Number(this.form.type);
          API.updateIntegralConfig(this.form).then((res) => {
            if (res.code === 200) {
              this.$message({
                type: "success",
                message: "编辑成功",
              });
              this.dialogVisible = false;
              this.getList();
            } else {
              this.$message({
                type: "error",
                message: "编辑失败",
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    // 关闭窗口清除数据
    handleClose() {
      this.form.id = undefined;
      this.form.name = "";
      this.form.bgImg = "";
      this.form.duration = 0;
      this.form.desc = undefined;
      this.form.prizePrice = undefined;
      this.form.prize = undefined;
      this.form.price = 0;
      this.form.status = 1;
      this.dialogVisible = false;
    },
    // 分页条数改变回调
    changeSize(size) {
      this.params.limit = size;
      this.getList();
    },
    // 分页页码改变回调
    changeCurrent(pageNumber) {
      this.params.page = pageNumber;
      this.getList();
    },
    // 更换时间格式
    changeTime(time) {
      return uniteDate(time);
    },
  },
};
</script>
<style lang="scss" scoped>
.dialog-footer {
  position: relative;
  left: 50%;
  -webkit-transform: translate(-50%);
  transform: translate(-50%);
}
/deep/ .el-form-item__content {
  display: flex;
}
/deep/ .el-select {
  width: 100%;
}
/deep/ .desc {
  display: none;
}
.form-flex-box {
  display: flex;
  .el-form-item {
    flex: 1;
  }
}
.tagBox {
  display: inline-block;
  margin-right: 5px;
}
</style>
